const m = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agus", "Sept", "Okt", "Nov", "Des"]
const getCustomMonth = (data) => {
    return m[data]
}

export default getCustomMonth